import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowCardContent: Components<Theme>['MuiCardContent'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      // need to override MUI default style
      '&, &:last-child': {
        padding: '16px',
      },
    },
  },
};
